/**
 * Mute service
 * Shares each participant's microphone state through the server
 * and handles the host's request to mute a participant.
 */
class MuteService {
  constructor() {
    this.socket = null;
    this.roomId = null;
    this.mutedPeers = {};
    this.subscribers = new Set();
    this.onForceMute = null;
    this.handlers = {};
  }

  subscribe(fn) {
    this.subscribers.add(fn);
    fn(this.mutedPeers);
    return () => {
      this.subscribers.delete(fn);
    };
  }

  notify() {
    this.subscribers.forEach((fn) => fn(this.mutedPeers));
  }

  setForceMuteHandler(fn) {
    this.onForceMute = fn;
  }

  attach(socket, roomId) {
    Object.entries(this.handlers).forEach(([ev, fn]) => this.socket && this.socket.off(ev, fn));
    this.handlers = {
      'audio-status': (d) => {
        this.mutedPeers = { ...this.mutedPeers, [d.userId]: !!d.muted };
        this.notify();
      },
      'force-mute': () => {
        if (this.onForceMute) this.onForceMute();
      },
    };
    this.mutedPeers = {};
    this.socket = socket;
    this.roomId = roomId;
    Object.entries(this.handlers).forEach(([ev, fn]) => socket.on(ev, fn));
    this.notify();
  }

  setMuted(muted) {
    if (!this.socket) return;
    this.socket.emit('audio-status', { roomId: this.roomId, muted: !!muted });
  }

  mutePeer(targetId) {
    if (!this.socket) return;
    this.socket.emit('mute-participant', { roomId: this.roomId, targetId });
  }
}

const muteService = new MuteService();
export default muteService;
